"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJsonTree = _interopRequireDefault(require("react-json-tree"));

var _LogMonitorEntryAction = _interopRequireDefault(require("./LogMonitorEntryAction"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var styles = {
  entry: {
    display: 'block',
    WebkitUserSelect: 'none'
  },
  root: {
    marginLeft: 0
  }
};

var getDeepItem = function getDeepItem(data, path) {
  return path.reduce(function (obj, key) {
    return obj && obj[key];
  }, data);
};

var dataIsEqual = function dataIsEqual(data, previousData, keyPath) {
  var path = _toConsumableArray(keyPath).reverse().slice(1);

  return getDeepItem(data, path) === getDeepItem(previousData, path);
};

var LogMonitorEntry =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LogMonitorEntry, _PureComponent);

  var _super = _createSuper(LogMonitorEntry);

  function LogMonitorEntry() {
    var _this;

    _classCallCheck(this, LogMonitorEntry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function (e) {
      var _this$props = _this.props,
          actionId = _this$props.actionId,
          onActionClick = _this$props.onActionClick,
          onActionShiftClick = _this$props.onActionShiftClick;

      if (actionId > 0) {
        if (e.shiftKey) {
          onActionShiftClick(actionId);
        } else {
          onActionClick(actionId);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldExpandNode", function (keyPath, data, level) {
      return _this.props.expandStateRoot && level === 0;
    });

    return _this;
  }

  _createClass(LogMonitorEntry, [{
    key: "printState",
    value: function printState(state, error) {
      var _this2 = this;

      var errorText = error;

      if (!errorText) {
        try {
          var data = this.props.select(state);
          var theme;

          if (this.props.markStateDiff) {
            var previousData = typeof this.props.previousState !== 'undefined' ? this.props.select(this.props.previousState) : undefined;

            var getValueStyle = function getValueStyle(_ref, nodeType, keyPath) {
              var style = _ref.style;
              return {
                style: _objectSpread(_objectSpread({}, style), {}, {
                  backgroundColor: dataIsEqual(data, previousData, keyPath) ? 'transparent' : _this2.props.theme.base01
                })
              };
            };

            var getNestedNodeStyle = function getNestedNodeStyle(_ref2, keyPath) {
              var style = _ref2.style;
              return {
                style: _objectSpread(_objectSpread({}, style), keyPath.length > 1 ? {} : styles.root)
              };
            };

            theme = {
              extend: this.props.theme,
              value: getValueStyle,
              nestedNode: getNestedNodeStyle
            };
          } else {
            theme = this.props.theme;
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement(_reactJsonTree["default"], {
              theme: theme,
              data: data,
              invertTheme: false,
              keyPath: ['state'],
              shouldExpandNode: this.shouldExpandNode
            })
          );
        } catch (err) {
          errorText = 'Error selecting state.';
        }
      }

      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            color: this.props.theme.base08,
            paddingTop: 20,
            paddingLeft: 30,
            paddingRight: 30,
            paddingBottom: 35
          }
        }, errorText)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actionId = _this$props2.actionId,
          error = _this$props2.error,
          action = _this$props2.action,
          state = _this$props2.state,
          collapsed = _this$props2.collapsed,
          selected = _this$props2.selected,
          inFuture = _this$props2.inFuture;
      var styleEntry = {
        opacity: collapsed ? 0.5 : 1,
        cursor: actionId > 0 ? 'pointer' : 'default'
      };
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            opacity: selected ? 0.4 : inFuture ? 0.6 : 1,
            // eslint-disable-line no-nested-ternary
            textDecoration: collapsed ? 'line-through' : 'none',
            color: this.props.theme.base06
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_LogMonitorEntryAction["default"], {
          theme: this.props.theme,
          collapsed: collapsed,
          action: action,
          expandActionRoot: this.props.expandActionRoot,
          onClick: this.handleActionClick,
          style: _objectSpread(_objectSpread({}, styles.entry), styleEntry)
        }), !collapsed &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            paddingLeft: 16
          }
        }, this.printState(state, error)))
      );
    }
  }]);

  return LogMonitorEntry;
}(_react.PureComponent);

exports["default"] = LogMonitorEntry;

_defineProperty(LogMonitorEntry, "propTypes", {
  state: _propTypes["default"].object.isRequired,
  action: _propTypes["default"].object.isRequired,
  actionId: _propTypes["default"].number.isRequired,
  select: _propTypes["default"].func.isRequired,
  inFuture: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  onActionClick: _propTypes["default"].func.isRequired,
  onActionShiftClick: _propTypes["default"].func.isRequired,
  collapsed: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  expandActionRoot: _propTypes["default"].bool,
  expandStateRoot: _propTypes["default"].bool,
  previousState: _propTypes["default"].object
});